export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const DefaultPageSize = 10;
export const EncryptKey = '!@#$YAT';
export const DecryptKey = '!@#$YCT';
export const LoggedUser = 'LoggedUser';
export const UserAvatar = 'UserAvatar';
export const TokenName = 'SML_AuthToken';
export const RefreshTokenName = 'RefreshToken';

// DATE FORMATS
export const DEFAULT_DATE_SINGLE_DAY = 'd';
export const DEFAULT_DATE_YEAR_MONTH_DAY = 'yyyy-MM-d';
export const DEFAULT_DATE_YEAR_MONTH_DAYS = 'yyyy-MM-dd';
export const DEFAULT_DATE_DAY_MONTH_YEAR = 'dd-MM-yyyy';
export const DEFAULT_DATE_MONTH_DAY_YEAR = 'MM/dd/yyyy';
export const DEFAULT_DATE_ISO = "yyyy-MM-dd'T'HH:mm:ss";
export const DEFAULT_DATE_ISO_WITHOUT_SECONDS = "yyyy-MM-dd'T'HH:mm";
export const DEFAULT_DATE_DAY_OF_WEEK = 'EEE';
export const DEFAULT_DATE_DAY_OF_WEEK_2 = 'EEEEEE';
export const DEFAULT_DATE_MONTH = 'MMMM';
export const DEFAULT_DATE_CALENDAR_YEAR = 'yyyy';
export const DEFAULT_DATE_MONTH_DAYOFMONTH_YEAR = 'MMMM dd, yyyy';

// LOADING STATE
export enum Statuses {
  UNINITIALIZED = 'uninitialized',
  LOADING = 'loading',
  LOADED = 'loaded',
}

export const FILE_FORMAT = {
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: 'pdf',
  OTHER: 'other',
} as const;

export const FILE_TYPE = {
  JPEG: '.jpeg',
  JPG: '.jpg',
  PNG: '.png',
  // HEIF: '.heif',
  // HEIC: '.heic',
  WEBP: '.webp',
  JFIF: '.jfif',
} as const;

export const DOC_TYPE = {
  JPEG: '.jpeg',
  JPG: '.jpg',
  PNG: '.png',
  PDF: '.pdf',
  DOCX: '.docx',
  XLSX: '.xlsx',
  TXT: '.txt',
} as const;

export const IMAGE_EXTENSION_TYPE = {
  JPEG: '.jpeg',
  JPG: '.jpg',
  PNG: '.png',
  HEIF: '.heif',
  HEIC: '.heic',
  WEBP: '.webp',
  JFIF: '.jfif',
} as const;

export const DOCUMENT_EXTENSION_TYPE = {
  PDF: '.pdf',
  DOCX: '.docx',
  XLSX: '.xlsx',
  TXT: '.txt',
  DOC: '.doc',
  XLS: '.xls',
  CSV: '.csv',
  BMP: '.bmp',
} as const;

export const ACCEPTED_FILE_TYPES =
  'image/jpeg, image/jpg, image/png, image/heic, image/heif, image/jfif, image/webp';
export const ACCEPTED_DOCUMENT_TYPES =
  'image/jpeg, image/jpg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain';
export const STORY_ACCEPTED_FILE_TYPES = 'image/jpeg, image/jpg, image/png, video/mp4, audio/mpeg';
export const BUTTON_TEXT = {
  CANCEL_TEXT: 'Cancel',
  SAVE_TEXT: 'Save',
} as const;


export const DOWNLOAD_INPROGRESS = `Your download has been initiated. Once complete, the file will be available in your 'Downloads' folder.`;